import React from 'react';
import VideoFeed from '@/components/VideoFeed';

const OffTheRecord = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#1A1F2C] to-black/90 pt-40">
      <main className="relative h-[calc(100vh-80px)] flex items-center justify-center">
        <div className="w-full max-w-[350px] h-[500px]">
          <VideoFeed />
        </div>
      </main>
    </div>
  );
};

export default OffTheRecord;